export const DnDItemTypes = {
  PHOTO: "photo",
};
